<template>
  <div class="dragUpload" @dragleave="dragleaveFn">
    <el-upload
      class="upload"
      drag
      multiple
      :action="uploadUrl"
      :headers="header"
      :on-progress="uploadProgress"
      :on-success="success"
      :on-error="err"
      :before-upload="beforeAvatarUpload"
      :with-credentials="true"
      :on-change="filesChange"
      :data="uploadParameter"
      :show-file-list="false"
      ref="uploader"
    >
      <div class="container">
        <img src="@/assets/img/printingPage/uploaddrag.png" alt="" />
        <p>释放鼠标完成</p>
      </div>
    </el-upload>
    <!-- 上传进度弹窗
    <el-dialog
      :visible.sync="showUploadProgress"
      width="400px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="title" slot="title">
        <span>生成中</span>
        <div class="close" @click="closeFn">
          <i class="icon"></i>
        </div>
      </div>
      <div class="uploadProgress">
        <div class="icon">
          <img src="@/assets/img/printing/production.png" alt="生产中" />
        </div>
        <span>{{ uploadParameter.fileName }}</span>
        <p>正在生成打印预览</p>
        <el-progress
          color="#1a4bff"
          :percentage="percentage"
          :show-text="false"
          status="exception"
        ></el-progress>
        <span slot="footer" class="dialogFooter">
          <el-button @click="cancelUploadFn">取 消</el-button>
        </span>
      </div>
    </el-dialog> -->
  </div>
</template>

<script type="text/javascript">
import uploadMixin from "mixins/upload.js";
import { fileQuery } from "api/api";

export default {
  name: "upload",
  components: {},
  data() {
    return {
      //上传文件参数
      uploadParameter: {
        fileName: ""
      },
      uploadErr: false //文件上传是否失败
    };
  },
  mixins: [uploadMixin],
  methods: {
    //拖拽离开
    dragleaveFn() {
      this.$emit("dragleaveFn");
    },
    //查询转换文档信息
    fileQueryFn(printNo) {
      fileQuery(printNo)
        .then(res => {
          const { code, data } = res;
          if (code === 0) {
            if (data.status !== 6 && data.status !== 5) {
              this.fileQueryFn(data.printNo);
            } else {
              // 上传成功，展示打印选项弹窗
              this.$emit("successFile", true);
              //将printNo、targetDocId传给打印选项弹窗
              sessionStorage.setItem("printParams", JSON.stringify(data));
              //关闭当前弹窗
              this.closeFn();
            }
          }
        })
        .catch();
    },
    //文件上传失败
    err() {
      this.uploadErr = true;
      this.$refs.uploader.clearFiles();
    },
    //取消文件上传
    cancelUploadFn() {
      this.$refs.uploader.abort();
      this.dragleaveFn();
    },
    //弹窗关闭
    closeFn() {
      this.$refs.uploader.abort();
      this.dragleaveFn();
    }
  }
};
</script>

<style lang="scss" scoped>
.dragUpload {
  width: 100%;
  height: 100%;
  background-color: white;
}
.upload {
  width: 100%;
  // height: 100%;
  min-height: 750px;
  position: relative;
  z-index: 2;
}
.container {
  letter-spacing: 1px;
  color: $theme-color;
  font-size: 20px;
  position: relative;
  z-index: -1;
  p {
    margin: 30px 0 0 0;
  }
}
::v-deep .el-upload,
::v-deep .el-upload-dragger {
  width: 100%;
  // height: calc(100% - 50px);
  min-height: 750px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  span {
    font-size: 16px;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 14px;
}
.close i {
  display: block;
  background: url("~@/assets/img/printing/closeIcon.png") no-repeat center;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.itemList {
  margin: 20px 0 10px 0;
  li {
    box-sizing: border-box;
    width: 352px;
    height: 52px;
    background-color: #f8f8f8;
    border-radius: 4px;
    margin: 10px 0 0 0;
    font-size: 14px;
    color: #424242;
    display: flex;
    align-items: center;
    padding: 0 0 0 20px;
    cursor: pointer;
    &:first-child {
      margin: 0;
    }
    &:hover {
      background-color: #eeeeee;
      color: $theme-color;
    }
    img {
      margin: 0 14px 0 0;
    }
  }
}
.codeBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666666;
  font-size: 16px;
  .codeIcon {
    position: relative;
    &:hover {
      .mask {
        display: block;
      }
      .button {
        display: block;
      }
    }
  }
  p {
    margin: 20px 0 0 0;
  }
  .mask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 180px;
    background: #000000;
    opacity: 0.7;
  }
  .button {
    display: none;
  }
  .buttonBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -20px 0 0 -60px;
    width: 120px;
    height: 40px;
    border-radius: 20px;
    border: solid 1px #ffffff;
    span {
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    span.saveAs {
      padding: 0 6px 0 10px;
    }
    span.copy {
      padding: 0 10px 0 6px;
    }
  }
}

.uploadProgress {
  text-align: center;
  span {
    display: inline-block;
    color: #999999;
    font-size: 12px;
    line-height: 20px;
    margin: 24px 0 0 0;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  p {
    color: #333333;
    font-size: 16px;
  }
}
.icon {
  width: 56px;
  height: 56px;
  margin: 0 auto;
  background-color: $theme-color;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploadProgress .dialogFooter {
  margin: 0;
  button {
    padding: 0px 20px;
    height: 32px;
  }
}

::v-deep .el-dialog__header {
  border-bottom: solid 1px #eeeeee;
  margin: 0 10px;
  padding: 0;
}
::v-deep .el-progress {
  margin: 18px 0 20px 0;
}
::v-deep .uploadProgress .el-progress-bar .el-progress-bar__outer {
  height: 4px !important;
}
</style>
